import Config from '@config';
import getPickUnit from '@helpers/getPickUnit';

interface StepperLayoutProps {
  currentQuantity: number;
  isActive: boolean;
  incrementValue?: number;
  unit?: string;
  hideWhenEmpty?: boolean;
  outOfStock?: boolean;
  shouldEnableWhenOpenOrder?: boolean;
}

const getStepperLayout = ({
  currentQuantity,
  incrementValue = 1,
  unit = 'pieces',
  hideWhenEmpty = false,
  isActive,
  outOfStock,
  shouldEnableWhenOpenOrder = false,
}: StepperLayoutProps) => {
  const minAmount = Config.PRODUCT.MIN_AMOUNT;
  const maxAmount = Config.PRODUCT.MAX_AMOUNT;

  // Hide minus button and input when quantity is 0
  const hidden = hideWhenEmpty && currentQuantity <= 0;

  const increaseTo = +parseFloat(String(currentQuantity + incrementValue)).toFixed(2);
  const decreaseTo = +parseFloat(String(currentQuantity - incrementValue)).toFixed(2);
  const incrementDisabled = currentQuantity >= maxAmount && !isActive;
  const decreaseDisabled = currentQuantity - incrementValue < minAmount;

  // Normalize unit codes (e.g. "ST", "KG") to translation keys ("pieces", "kilogram")
  const normalizedUnit = getPickUnit(unit);
  const showOutOfStock = outOfStock && !shouldEnableWhenOpenOrder;

  return {
    hidden,
    increaseTo,
    decreaseTo,
    incrementDisabled,
    decreaseDisabled,
    normalizedUnit,
    showOutOfStock,
  };
};

export default getStepperLayout;
